import { all, fork } from "redux-saga/effects";

// ===== Existing System Sagas =====
import { projectsWatcherSaga } from "./projectsSaga";

// ===== Entity Sagas =====
import { auditlogSaga as auditLogWatcherSaga } from "./auditlogSaga";
import { brandSaga as brandWatcherSaga } from "./brandSaga";
import { companySaga as companyWatcherSaga } from "./companySaga";
import { designSaga as designWatcherSaga } from "./designSaga";
import { designversionSaga as designVersionWatcherSaga } from "./designversionSaga";
import { documentSaga as documentWatcherSaga } from "./documentSaga";
import { engagementSaga as engagementWatcherSaga } from "./engagementSaga";
import { fabricoptionSaga as fabricOptionWatcherSaga } from "./fabricoptionSaga";
import { ledgerentrySaga as ledgerEntryWatcherSaga } from "./ledgerentrySaga";
import { manufacturerSaga as manufacturerWatcherSaga } from "./manufacturerSaga";
import { notificationSaga as notificationWatcherSaga } from "./notificationSaga";
import { orderSaga as orderWatcherSaga } from "./orderSaga";
import { orderdispatchSaga as orderDispatchWatcherSaga } from "./orderdispatchSaga";
import { orderestimateSaga as orderEstimateWatcherSaga } from "./orderestimateSaga";
import { orderlineitemSaga as orderLineItemWatcherSaga } from "./orderlineitemSaga";
import { ordertimelineeventSaga as orderTimelineEventWatcherSaga } from "./ordertimelineeventSaga";
import { paymentreceiptSaga as paymentReceiptWatcherSaga } from "./paymentreceiptSaga";
import { requirementSaga as requirementWatcherSaga } from "./requirementSaga";
import { userSaga as userWatcherSaga } from "./userSaga";
import { workflowtaskSaga as workflowTaskWatcherSaga } from "./workflowtaskSaga";
import { reportSaga } from "./reportSaga";
import { commentSaga } from "./commentSaga";
import { debitcategorySaga } from "./debitcategorySaga";

export default function* rootSaga() {
  yield all([
    // System Sagas
    fork(projectsWatcherSaga),

    // Entity Sagas
    fork(auditLogWatcherSaga),
    fork(brandWatcherSaga),
    fork(companyWatcherSaga),
    fork(designWatcherSaga),
    fork(designVersionWatcherSaga),
    fork(documentWatcherSaga),
    fork(engagementWatcherSaga),
    fork(fabricOptionWatcherSaga),
    fork(ledgerEntryWatcherSaga),
    fork(manufacturerWatcherSaga),
    fork(notificationWatcherSaga),
    fork(orderWatcherSaga),
    fork(orderDispatchWatcherSaga),
    fork(orderEstimateWatcherSaga),
    fork(orderLineItemWatcherSaga),
    fork(orderTimelineEventWatcherSaga),
    fork(paymentReceiptWatcherSaga),
    fork(requirementWatcherSaga),
    fork(userWatcherSaga),
    fork(workflowTaskWatcherSaga),
    fork(reportSaga),
    fork(commentSaga),
    fork(debitcategorySaga),
  ]);
}
